import React from "react";

const CheckPatientModal = ({ ismodal,submit, status, setIsmodal, data, athenaResult }) => {
  if (!ismodal || !data) return null;

  const isFound = status;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md w-[90%] max-w-md p-6 relative shadow-lg">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
          onClick={() => setIsmodal(false)}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Modal Content */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold border-b pb-2">Patient Details</h2>

          <div className="border rounded-md bg-gray-50 p-4 text-start space-y-2">
            <p className="text-base">
              <span className="font-semibold">Name:</span> {data?.firstname} {data?.lastname}
            </p>
            <p className="text-base">
              <span className="font-semibold">DOB:</span> {data?.dob}
            </p>
            <p className="text-base">
              <span className="font-semibold">Patient ID:</span>
              {data?.patientid ?? athenaResult?.[0]?.patientid ?? ""}
            </p>
          </div>

          {/* Conditional Content */}
          {isFound === true ? (
            <p className="text-red-600 font-medium text-base">
              Patient already exists. Please check Athena to verify the information.
            </p>
          ) : isFound === false ? (
            <div className="flex justify-end">
              <button
                onClick={() => {
                  // Submit to EMR logic here
                  console.log("Submitting to EMR...");
                 submit()
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Submit to EMR
              </button>
            </div>
          ) : (
            <p className="text-yellow-600 font-medium text-base">
              Something went wrong. Please try again later.
            </p>
          )}

          {/* Close Button */}
          {status&&<div className="flex justify-end">
            <button
              onClick={() => setIsmodal(false)}
              className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
            >
              Close
            </button>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default CheckPatientModal;
